import { Button, Typography, notification } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { useForm } from "antd/es/form/Form";
import { postAddEpisode } from "../../api/Post";
import FormEpisode from "./FormEpisode";

const { Paragraph } = Typography;

const Context = React.createContext({ name: "Default" });

const AddEpisode = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { serie, seasons } = state;

  const [form] = useForm();

  const [errorMsg, setErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [api, contextHolder] = notification.useNotification();

  const openNotification = (episode) => {
    api.success({
      message: `Épisode ${episode.number} enregistré`,
      description: (
        <>
          <Paragraph>{episode.name}</Paragraph>
          <Button
            type="link"
            onClick={() => {
              navigate(`/episode/${episode.id}/gpt`, {
                state: { episode, serie },
              });
            }}
          >
            Passer à l'intégration
          </Button>
        </>
      ),
      placement: "topLeft",
    });
  };

  const onFinish = async (values) => {
    setIsLoading(true);

    const { author, epCover, illustrator, epName, epNumber, epState, saison } =
      values;

    const formData = new FormData();
    if (epCover) formData.append("fileToUpload", epCover.file);
    formData.append("author", author);
    formData.append("illustrator", illustrator);
    formData.append("epName", epName);
    formData.append("epState", epState);

    const res = await postAddEpisode(formData, saison, epNumber);
    if (res.error) setErrorMsg(res.error);
    else {
      const indexS = seasons.findIndex((s) => {
        return s.id === saison;
      });
      if (seasons[indexS].Episodes) seasons[indexS].Episodes.push(res.ep);
      else seasons[indexS]["Episodes"] = [res.ep];
      form.resetFields();
      form.setFieldsValue({
        epNumber: seasons[indexS].Episodes.length + 1,
      });
      openNotification(res.ep);
    }
    setIsLoading(false);
  };

  return (
    <>
      <Context.Provider value={{ name: "AddEpisode" }}>
        {contextHolder}
        <FormEpisode
          title={`Ajouter un épisode`}
          onFinish={onFinish}
          initialValues={{
            saison: seasons[0].id,
            epState: "admin",
            epNumber: seasons[0].Episodes?.length + 1 || 1,
            illustrator: seasons[0].illustrator,
            author: seasons[0].author,
          }}
          errorMsg={errorMsg}
          isLoading={isLoading}
          form={form}
        />
      </Context.Provider>
    </>
  );
};

export { AddEpisode };
